import { svgIconClasses as p, Fab as o, fabClasses as s } from "@mui/material";
import { css as t, styled as a } from "./styled2.mjs";
const i = t`
	font-size: 12px;
	min-height: 20px;
	width: 20px;
	height: 20px;

	.${p.root} {
		font-size: 16px;
	}
`, d = a(o)`
	&.${s.root} {
		border-radius: 50%;
		box-shadow: 0px 1px 18px 0px #0000000d, 0px 6px 10px 0px #0000000d,
			0px 3px 5px -1px #0000000d;
		${({ $extraSmall: x }) => x && i};
	}
`;
export {
  d as Fab
};
//# sourceMappingURL=styles65.mjs.map
